/*
  Product view/click tracking. Fires anonymous, fire-and-forget beacons at
  hostinger-shopify/api/tracking/track.php — the actual Shopify metafield
  write happens later, in bulk, via that module's sync-metafields.php cron.

  Loaded once from layout/theme.liquid (not per-card), same reasoning as
  assets/wishlist.js: a <script> rendered inside a snippet that later gets
  swapped into the page via container.innerHTML never executes, so this
  can't live inline in a card snippet — it has to be a real global script.

  - View: fires once per page load, only on product pages
    (window.SYC_PRODUCT_TRACKING.productId, set from Liquid in theme.liquid).
  - Click: delegated document-level listener for any element carrying
    data-track-product-id — works for cards injected via AJAX (SRA filter
    swaps, the wishlist page's client-built cards) with no separate re-init
    hook needed.
*/
(function () {
  var TRACK_URL = 'https://admin.seuyco.com/shopify/api/tracking/track.php';

  function send(productId, catalogId, type) {
    productId = parseInt(productId, 10);
    if (!productId) return;
    catalogId = parseInt(catalogId, 10) || null;

    var payload = JSON.stringify({ product_id: productId, catalog_id: catalogId, type: type });

    // Not sendBeacon: it sends cross-origin requests in no-cors mode, which
    // only allows a handful of "safelisted" content types (text/plain,
    // multipart/form-data, application/x-www-form-urlencoded) — this
    // endpoint lives on a different origin (admin.seuyco.com) and needs
    // application/json, so sendBeacon would silently drop or mangle it in
    // several browsers. `keepalive` gives fetch the same "survive the page
    // unload a click-through triggers" behavior sendBeacon was here for.
    fetch(TRACK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true
    }).catch(function () {});
  }

  var cfg = window.SYC_PRODUCT_TRACKING || {};
  if (cfg.productId) {
    send(cfg.productId, cfg.catalogId, 'view');
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-track-product-id]');
    if (!link) return;
    send(link.getAttribute('data-track-product-id'), link.getAttribute('data-track-catalog-id'), 'click');
  }, true);
})();
